import { DateTime } from 'luxon';
import { CouponDiscountType, Coupon } from './coupon';

export namespace CouponParsers {
  export class CouponJson {
    id!: number;
    code!: string;
    minOrderSubtotal?: number;
    discountType!: CouponDiscountType;
    value!: number;
    maxValue?: number;
    startDate!: string;
    endDate!: string;
    usesTotal!: number;
    usesPerCustomer!: number;
    freeShipping!: boolean;
    isActive!: boolean;
    isDeleted!: boolean;
    isVip!: boolean;
    productIds?: number[];
    categoryIds?: number[];
  }

  export function toCoupon(input: CouponJson): Coupon {
    return {
      ...input,
      startDate: DateTime.fromISO(input.startDate),
      endDate: DateTime.fromISO(input.endDate),
    };
  }
}
